import { AdminDashboardCollabsStaticsResponse, AdminDashboardDataFilter } from '../../graphql/API';
import { adminGetDashboardCollabsData } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminGetDashboardCollabsDataApi = async (
  filter: AdminDashboardDataFilter,
): Promise<AdminDashboardCollabsStaticsResponse> => {
  const result = await executeGql(adminGetDashboardCollabsData, { filter });
  return processGqlResult<AdminDashboardCollabsStaticsResponse>(
    'adminGetDashboardCollabsData',
    result,
  );
};
